import { useEffect, useState, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { hasLiveSession, loginPath } from '../utils/login-return';

/**
 * Shows its page only to a visitor with a sign-in that has not expired. Anyone else goes to the
 * login page, which returns to the page asked for.
 */
const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (hasLiveSession()) {
      setAllowed(true);
      return;
    }
    setAllowed(false);
    navigate(loginPath(`${pathname}${search}${hash}`), { replace: true });
  }, [navigate, pathname, search, hash]);

  return allowed ? <>{children}</> : null;
};

export default ProtectedRoute;
